import React from 'react';

const Actions = ({ children }) => <div className="ws-ui-editor-header__actions">{children}</div>;

export default Actions;
